<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Tipos listas de precios por término de pago</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Tipos listas de precios por término de pago</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="companiaSeleccionada != null" class="readonly-form-field"
                        color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Compania}}</mat-label>

                        <input readonly [value]="companiaSeleccionada.id + ' - ' + companiaSeleccionada.descripcion"
                            type="text" matInput>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="salesOrgSeleccionada != null" class="readonly-form-field"
                        color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.SalesOrg}}</mat-label>

                        <input readonly [value]="salesOrgSeleccionada.id + ' - ' + salesOrgSeleccionada.descripcion"
                            type="text" matInput>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdTerminoPago}}</mat-label>
                        <mat-select (selectionChange)="seleccionarTerminoPago($event.value)"
                            [compareWith]="compareTerminosPago" formControlName="idTerminoPago">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let t of terminosPago" [value]="t.id">{{t.descripcion}}
                            </mat-option>
                        </mat-select>

                        <mat-error
                            *ngIf="(form.get('idTerminoPago').hasError('required')) && form.get('idTerminoPago').touched ">
                            {{Validaciones.IdTerminoPago}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdTipoListaPrecios}}</mat-label>
                        <mat-select (selectionChange)="seleccionarTipoListaPrecios($event.value)"
                            [compareWith]="compareTipoListaPrecios" formControlName="idTipoListaPrecios">
                            <mat-option [value]="">- Seleccione -</mat-option>
                            <mat-option *ngFor="let tlps of tiposLP" [value]="tlps.id">{{tlps.descripcion}}
                            </mat-option>
                        </mat-select>

                        <mat-error
                            *ngIf="(form.get('idTipoListaPrecios').hasError('required')) && form.get('idTipoListaPrecios').touched ">
                            {{Validaciones.IdTerminoPago}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox class="cell" formControlName="habilitacion" color="primary-darker">
                        {{Etiquetas.Habilitacion}}
                    </mat-checkbox>

                </div>

            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardar()" [disabled]="form.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>
